module.exports = __webpack_public_path__ + "static/media/error-icon.faa6cb47.svg";